/*
 * customize venue small to point original location and original image
 */

import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { flattenToAppURL } from '@plone/volto/helpers';
import { contentHasImage } from 'design-comuni-plone-theme/helpers';
import { Icon } from 'design-comuni-plone-theme/components/ItaliaTheme';
import config from '@plone/volto/registry';
import React, { useEffect, useState } from 'react';
import { UniversalLink } from '@plone/volto/components';

const messages = defineMessages({
  VenuesSmall: {
    id: 'VenuesSmall',
    defaultMessage: 'Luoghi',
  },
  details: {
    id: 'details',
    defaultMessage: 'Maggiori dettagli',
  },
});

/**
 * Location view component class (internal).
 * @function Location
 * @params {object} location: object.
 * @params {boolean} show_icon:
 * @returns {string} Markup of the component.
 */
const Location = ({ location, show_icon }) => {
  const intl = useIntl();
  const Image = config.getComponent({ name: 'Image' }).component;
  const showImage = contentHasImage(location);

  const [isSameDomain, setIsSameDomain] = useState(true); // Default per SSR
  const [locationUrl, setLocationUrl] = useState(location['@id']);

  useEffect(() => {
    const locationHost = new URL(location['@id']).host;
    const isSame = window.location.host === locationHost;
    setIsSameDomain(isSame);
    setLocationUrl(isSame ? flattenToAppURL(location['@id']) : location['@id']);
  }, [location]);

  let correct_location = location;
  if (location?.original_id) {
    correct_location = {
      ...structuredClone(location),
      '@id': location.original_id,
    };
  }

  return (
    correct_location && (
      <div className="card card-teaser shadow border-left-card mt-3 card-small rounded location-item">
        <div className="card-body">
          <div className="card-title h5">
            {show_icon && <Icon icon={'it-pin'} />}
            {correct_location.title}
          </div>
          <div className="card-text">
            {(correct_location.street || correct_location.zip_code) && (
              <p>
                {correct_location.street && correct_location.street}
                {correct_location.street && correct_location.zip_code
                  ? ' - '
                  : ' '}
                {correct_location.zip_code}
              </p>
            )}
            <p className="mt-3">
              <UniversalLink
                href={locationUrl}
                title={correct_location.title}
                openLinkInNewTab={true}
              >
                {intl.formatMessage(messages.details)}
              </UniversalLink>
            </p>
          </div>
        </div>
        {showImage && (
          <div className="avatar size-lg">
            <Image item={correct_location} loading="lazy" sizes="80px" />
          </div>
        )}
      </div>
    )
  );
};

/**
 * VenuesSmall view component class. Used in NewsItemLuoghiCorrelati, subcomponent of NewsItemView.
 * @function VenuesSmall
 * @params ...
 * @returns {string} Markup of the component.
 */
const VenuesSmall = ({ venues, show_icon }) => {
  return venues ? (
    <div className="card-wrapper card-teaser-wrapper align-items-stretch">
      {venues.map((item) => (
        <Location key={item['@id']} location={item} show_icon={show_icon} />
      ))}
    </div>
  ) : null;
};
export default VenuesSmall;

VenuesSmall.propTypes = {
  VenuesSmall: PropTypes.arrayOf(
    PropTypes.shape({
      '@id': PropTypes.string,
      '@type': PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      review_state: PropTypes.string,
    }),
  ),
  show_icon: PropTypes.bool,
};

Location.propTypes = {
  location: PropTypes.shape({
    '@id': PropTypes.string,
    '@type': PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    review_state: PropTypes.string,
  }),
  show_icon: PropTypes.bool,
};
